"use strict";

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = isValueLengthLessThan;
function isValueLengthLessThan(value, digits) {
    return value != null && value.length <= digits;
}